import { c as _c } from "react/compiler-runtime";
import type { RecommendedPlanResult } from '@/lib/billing/recommended-plan';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { recommendedPlanQueryKey } from './query-keys';
async function fetchRecommendedPlan(installationId: number, seats?: number | null): Promise<RecommendedPlanResult> {
  const params = new URLSearchParams({
    installationId: String(installationId)
  });
  if (seats && seats > 0) {
    params.set('seats', String(seats));
  }
  const response = await fetch(`/api/billing/recommended-plan?${params.toString()}`);
  if (!response.ok) {
    throw new Error('Failed to fetch recommended plan');
  }
  return response.json();
}
export function useRecommendedPlan(installationId, seats) {
  const $ = _c(10);
  let t0;
  if ($[0] !== installationId || $[1] !== seats) {
    t0 = recommendedPlanQueryKey(installationId, seats);
    $[0] = installationId;
    $[1] = seats;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== installationId || $[4] !== seats) {
    t1 = () => fetchRecommendedPlan(installationId, seats);
    $[3] = installationId;
    $[4] = seats;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = !!installationId;
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      placeholderData: keepPreviousData
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useQuery(t3);
}